export default __webpack_public_path__ + "static/media/work-12.c4def74b.jpg";